<!--
 * 文件名：LabelReqView.vue
 * 描述：数据标注"标注人员要求"纯详情视图（v26.3.3 共用组件，2026-09-16 受理页交互改造从 templateConfig 详情态抽出）。
 *       配置页详情态与受理页"查看"弹框两处复用；全部只读文本，无接口依赖——
 *       职称全量取编辑保存时落库的 titleNames 快照，不依赖职称字典加载。
 * 契约：conf=行级 labelConfig 解析对象（或同构表单对象）；缺省字段显示 —。
-->
<template>
  <div class="sjbz-req-view">
    <div class="sjbz-req-view-row">
      <!-- 2026-10-08 样式反馈：标签串较长，"选择标签"独占整行（--full），"模型选择"随 flex 换行，其余布局不变 -->
      <div class="sjbz-req-view-item sjbz-req-view-item--full">
        <div class="sjbz-req-view-label">选择标签</div>
        <div class="sjbz-req-view-value" :title="labelTemplateText">{{ labelTemplateText }}</div>
      </div>
      <div class="sjbz-req-view-item">
        <div class="sjbz-req-view-label">模型选择</div>
        <div class="sjbz-req-view-value" :title="conf.modelName">{{ conf.modelName || '—' }}</div>
      </div>
    </div>
    <div class="sjbz-req-subtitle">标注人员要求</div>
    <div class="sjbz-req-view-row">
      <div class="sjbz-req-view-item">
        <div class="sjbz-req-view-label">所属科室</div>
        <div class="sjbz-req-view-value" :title="conf.deptName">{{ conf.deptName || '—' }}</div>
      </div>
      <div class="sjbz-req-view-item">
        <div class="sjbz-req-view-label">标注人员身份</div>
        <div class="sjbz-req-view-value">{{ identityText || '—' }}</div>
      </div>
      <div class="sjbz-req-view-item">
        <div class="sjbz-req-view-label">{{ titleLabel }}</div>
        <div class="sjbz-req-view-value" :title="titleText">{{ titleText || '—' }}</div>
      </div>
      <div class="sjbz-req-view-item">
        <div class="sjbz-req-view-label">标注经验</div>
        <div class="sjbz-req-view-value" :title="conf.experience">{{ conf.experience || '—' }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LabelReqView",
  props: {
    /** 行级 labelConfig 解析对象（或同构表单对象），字段与编辑态同源 */
    conf: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    labelTemplateText() {
      // FOUR-3001：多标签（labelSnapshots 数组）优先，兼容旧单标签（labelSnapshot 对象）；
      // 标签名称为 | 合并串，展示统一中文顿号渲染（R4，与 LabelTemplateSelect optionLabel 口径一致）
      const snaps = (this.conf.labelSnapshots && this.conf.labelSnapshots.length)
        ? this.conf.labelSnapshots
        : (this.conf.labelSnapshot ? [this.conf.labelSnapshot] : []);
      const texts = snaps.map((s) => s && s.templateName && s.templateName.replace(/\|/g, '、')).filter(Boolean);
      return texts.length ? texts.join("；") : "—";
    },
    // 身份文案：快照存字典值（与 personnel 认证身份常量同源），静态映射即可
    identityText() {
      return { "1": "医生", "2": "护士", "3": "药师", "4": "技师", "5": "医学生", "6": "其他" }[this.conf.identity] || "";
    },
    titleLabel() {
      return this.conf.identity === "5" ? "标注人员专业" : "标注人员职称";
    },
    // 职称多选全量：编辑保存时已随 labelConfig 落库（sjbzReqSure），无需再查职称字典
    titleText() {
      if (this.conf.identity === "5") return this.conf.majorName || "";
      return (this.conf.titleNames || []).join("、");
    },
  },
};
</script>

<style scoped>
/* 自 templateConfig 详情态迁入（样式随组件走，两处弹框视觉一致） */
.sjbz-req-subtitle {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  text-align: left;
  padding: 4px 0 12px;
}
.sjbz-req-view {
  text-align: left; /* 抵御全局 #app text-align:center 波及 */
  padding: 0 4px;
}
.sjbz-req-view-row {
  display: flex;
  flex-wrap: wrap;
}
.sjbz-req-view-item {
  width: 50%;
  box-sizing: border-box;
  padding: 0 10px;
  margin-bottom: 18px;
}
/* 2026-10-08 样式反馈：长内容字段独占整行（选择标签为逗号分隔长串，半栏换行密集） */
.sjbz-req-view-item--full {
  width: 100%;
}
.sjbz-req-view-label {
  color: #909399;
  font-size: 13px;
  margin-bottom: 6px;
}
.sjbz-req-view-value {
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
</style>
